function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  fill: "#828ff7",
  d: "M0 4c0-2 2-4 4-4h8v56H4c-2 0-4-2-4-4z"
})), React.createElement("g", null, React.createElement("path", {
  fill: "none",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeMiterlimit: 50,
  strokeWidth: 3,
  d: "M6.5 20.5v16"
})));

var SvgVideoCropLeftHandler = function SvgVideoCropLeftHandler(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 12,
    height: 56,
    viewBox: "0 0 12 56",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgVideoCropLeftHandler, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/video_crop_left_handler.74b5a092.svg";
export { ForwardRef as ReactComponent };